<script>

    import { toast } from 'bulma-toast'
    import { userStore, notifyStore } from '../stores'

	import FacturamaService from "../$services/facturama.services";

    import Spinner from '../$components/spinner.svelte'

    $: $notifyStore === 'facturama_invoices_updated' && getInvoiceAmount() && notifyStore.set(null)

    let amount = 0
    let loading = false

    getInvoiceAmount()

    async function getInvoiceAmount() {
        loading = true
        const resp = await FacturamaService.getInvoiceAmount($userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        amount = resp.data
    }

</script>

<Spinner  {loading} />

{#if !loading}
    <h2 class="title is-4">Monto máximo a facturar</h2>
    <h1 class="subtitle is-4">${ amount }</h1>
{/if}